import { fetch } from '../request';
import type { IResponse, RequestConfig } from '../interface';

// 获取资源上传后地址
export const uploadMediaFile = (data: any, config?: RequestConfig) => {
  return fetch<IResponse>('/youyan/upload_media/', {
    method: 'POST',
    body: data,
    ...config,
  });
};

// 报错意见反馈
export const saveFeedback = (data: any, config?: RequestConfig) => {
  return fetch<IResponse>('/user/feedback_information/', {
    method: 'POST',
    body: data,
    ...config,
  });
};

// 纯上传
export const commonUpload = (data: any, config?: RequestConfig) => {
  return fetch<IResponse>('/youyan/upload_media/pure_upload_file/', {
    method: 'POST',
    body: data,
    ...config,
  });
};

// 发送通知
export const sendNotify = (data?: any) => {
  return fetch<IResponse>('/storage/repository/notify_full/', {
    method: 'POST',
    body: data,
  });
};
